import React from 'react';
import './AllocateFundBannerCard.scss';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const AllocateFundBannerCard = ({
	avatarUrl = '',
	onChooseAnotherFundraiserCTA = () => { },
	buttonText = 'PICK A FUNDRAISER',
	contentText = 'Please select a fundraiser that feels right for your upcoming SIP contribution'
}) => {
	return (
		<div className="allocate-fund-card">
			<div className="afc-content">
				<div className="afc-title-img-container">
					<div className="afc-title">
						<div>TAP</div>
						<div>CHOOSE</div>
						<div>DONE</div>
					</div>
					{avatarUrl && <div className="afc-avatar-wrapper">
						<img src={avatarUrl} alt="Fundraiser Avatar" className="afc-avatar" />
					</div>}
				</div>
				{contentText && <div className="afc-desc" dangerouslySetInnerHTML={{ __html: contentText }} />}
				<button className={`afc-btn ${buttonText === 'CHANGE SELECTION' ? 'outline-btn' : ''}`} onClick={onChooseAnotherFundraiserCTA}>
					{buttonText}<ArrowForwardIcon className='mfs-16 afc-arrow' />
				</button>
			</div>
		</div>
	);
};

export default AllocateFundBannerCard; 